import { useState } from 'react';
import { femaleLead, maleLead, sideCharacters } from '@/mocks/galData';

const galleryCharacters = [femaleLead, maleLead, ...sideCharacters];

export default function Gallery() {
  const [active, setActive] = useState('all');
  const roles = ['all', 'female-lead', 'male-lead', 'support'];

  const filtered = galleryCharacters.filter((c) => {
    if (active === 'all') return true;
    if (active === 'female-lead') return c.id === 'female-lead';
    if (active === 'male-lead') return c.id === 'male-lead';
    return sideCharacters.some((s) => s.id === c.id);
  });

  return (
    <section id="gallery" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 text-center">
          <span className="inline-block rounded-full bg-secondary-100 px-4 py-1.5 text-sm text-secondary-800">
            泡在我家的辣妹角色图
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
            角色图鉴：全员档案一次看全
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-foreground-700 md:text-base">
            女主、男主加上三个主要配角，泡在我家的辣妹所有角色图都集中在这里，点开任意卡片了解更多设定。
          </p>
        </div>

        <div className="mb-8 flex flex-wrap justify-center gap-2">
          {[
            { id: 'all', label: '全部角色' },
            { id: 'female-lead', label: '女主' },
            { id: 'male-lead', label: '男主' },
            { id: 'support', label: '配角团' },
          ].map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActive(tab.id)}
              className={`whitespace-nowrap rounded-full px-5 py-2 text-sm transition-colors ${
                active === tab.id
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-50 text-foreground-700 hover:bg-primary-100 hover:text-primary-700'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((char) => (
            <article
              key={char.id}
              className="group overflow-hidden rounded-3xl border border-background-200 bg-background-50 shadow-soft transition-transform hover:-translate-y-1"
            >
              <div className="relative h-72 overflow-hidden">
                <img
                  src={char.image}
                  alt={`${char.name} ${char.role}角色图`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-background-50/90 px-3 py-1 text-xs text-primary-700">
                  {char.role}
                </span>
                {char.id === 'female-lead' && (
                  <span className="absolute right-4 top-4 rounded-full bg-accent-400 px-3 py-1 text-xs text-foreground-950">
                    女主
                  </span>
                )}
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-lg text-foreground-950">{char.name}</h3>
                  <span className="text-xs text-foreground-600">#{char.alias}</span>
                </div>
                <p className="mt-2 text-sm leading-6 text-foreground-700">
                  {char.intro.length > 70 ? `${char.intro.slice(0, 70)}…` : char.intro}
                </p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {char.traits.map((trait) => (
                    <span
                      key={trait}
                      className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-800"
                    >
                      {trait}
                    </span>
                  ))}
                </div>
                <a
                  href={`#${char.id}`}
                  className="mt-4 inline-flex items-center gap-1 whitespace-nowrap text-sm text-primary-600 hover:text-primary-700"
                >
                  查看详细设定
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}